import { ValueObject, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class UpdateRawGenericExportMappingCommand extends ValueObject {
    
    public rawGenericExportMappingId: number = 0;
    
    public staticExportColumnSpecId: number = 0;

    public staticServiceProviderFileGroupingId: number = 0;

    public displayName: string = "";

    public isExcluded: boolean = false;
}